<template>
  <v-row no-gutters>
    <v-col
      cols="11"
      class="mx-auto text-right"
    >
      <v-btn-toggle
        v-model="view"
        class="rounded-lg"
        @change="toggleView()"
      >
        <v-btn value="grid-view" :class="{'disable-events': view == 'grid-view'}" data-testid="grid-button">
            <v-icon>mdi-view-grid</v-icon>
        </v-btn>
        <v-btn value="list-view" :class="{'disable-events': view == 'list-view'}" data-testid="list-button">
            <v-icon>mdi-view-list</v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: function () {
    return {
      view: window.$cookies && window.$cookies.isKey('viewMode') ?  window.$cookies.get('viewMode') : 'grid-view'
    };
  },
  methods: {
    toggleView(){
      window.$cookies.set("viewMode", this.view, Infinity, null, process.env.VUE_APP_DOMAIN)
      this.$emit('toggleView', this.view)
    }
  }
};
</script>

